import {
	Badge,
	Button,
	Center,
	Flex,
	Heading,
	Image,
	Link,
	Stack,
	Container,
	Text,
	useColorModeValue,
} from "@chakra-ui/react";

let allProjects = [
	// if links not available use "#" as values
	{
		id: 1,
		name: "Tanishq",
		hero_img: "https://i.ibb.co/Q9kCfRw/homepage.png",
		heading: "Tanishq Clone",
		description:
			"Tanishq is an Indian jewellery brand and a division of Titan Company.",
		badge_1: ["EJS", "MongoDB", "TailwindCSS"],
		badge_2: ["NodeJS", "ExpressJS", "MongoDB", "Mongoose"],
		git_repo: "https://github.com/Lakshay-Sachdeva/tanishq_clone",
		demo_video_drive_link:
			"https://drive.google.com/file/d/18JbhK3lxtYbZk5Unoi2PEeTCtGKEi5oB/view?usp=sharing",
		deployed_link: "https://tanishq-clone.herokuapp.com/",
		disableLiveSite: true
	},
	{
		id: 2,
		name: "InternTheory",
		hero_img: "https://i.ibb.co/SXDZgGD/Intern-Theory-Hero-Img.jpg",
		heading: "InternTheory Clone",
		description:
			"InternTheory is a platform to connect companies with students for possible internship opportunities across India.",
		badge_1: ["HTML5", "CSS3", "JavaScript"],
		badge_2: [],
		git_repo: "https://github.com/AbhijitAher/InternTheoryClone",
		demo_video_drive_link:
			"https://drive.google.com/file/d/196GdGOmM7s4_mYziAW2I-3HIHFTmStR4/view?usp=sharing",
		deployed_link: "https://interntheoryclone.netlify.app",
		disableLiveSite: false
	},
	{
		id: 3,
		name: "Zee5",
		hero_img: "https://i.ibb.co/nbpRJck/Hero.jpg",
		heading: "Zee5 Clone",
		description:
			"ZEE5 is an Indian subscription video on-demand and over-the-top streaming service, run by Zee Entertainment Enterprises.",
		badge_1: ["HTML", "CSS", "JavaScript"],
		badge_2: ["SplideJS"],
		git_repo: "https://github.com/AbhijitAher/Zee5_Clone",
		demo_video_drive_link:
			"https://drive.google.com/file/d/1cdam9qTa9zccXcipOb9VJi4sejUSkb7e/view?usp=sharing",
		deployed_link: "https://abhijitaher.github.io/Zee5_Clone/",
		disableLiveSite: false
	},
	{
		id: 4,
		name: "Memory-Game",
		hero_img: "https://i.ibb.co/X24Xx9j/memory-game-hero.jpg",
		heading: "Memory-Game",
		description: "This game was created using ReactJS",
		badge_1: ["ReactJS", "JSX", "CSS"],
		badge_2: [],
		git_repo: "https://github.com/AbhijitAher/memory-game-cards",
		demo_video_drive_link: "#",
		deployed_link: "https://memory-game-cards.vercel.app/",
		disableLiveSite: false
	},
];

// let miniProjects = [
// 	{
// 		name: "Temperature-Control",
// 		link: "https://in9c7l.csb.app/",
// 	},
// 	{
// 		name: "Digital-Timer",
// 		link: "https://e6k0pk.csb.app/",
// 	},
// ];

export default function Projects() {
	const bg_theme = useColorModeValue("white", "gray.900");
	const color_theme = useColorModeValue("gray.700", "gray.400");
	const badge_bg = useColorModeValue("gray.50", "gray.800");
	return (
		<>
			<Container maxW={"full"}>
				<Stack
					textAlign={"center"}
					align={"center"}
					spacing={{ base: 8, md: 10 }}
					py={{ base: 16, md: 26 }}
				>
					<Heading
						fontWeight={600}
						fontSize={{ base: "3xl", sm: "4xl", md: "6xl" }}
						lineHeight={"110%"}
					>
						<Text as={"span"} color={"blue.400"}>
							Projects
						</Text>
					</Heading>

					<Flex w={"full"}></Flex>
				</Stack>
			</Container>

			{allProjects.map((project) => {
				return (
					<Center
						py={6}
						name={project.name}
						w={{ base: "100%", md: "90%", lg: "70%" }}
						key={20 * Math.random()}
					>
						<Stack
							borderWidth="1px"
							borderRadius="lg"
							w={{ base: "70%", sm: "70%", md: "90%", lg: "90%" }}
							height={{ md: "20rem" }}
							direction={{ base: "column", md: "row" }}
							bg={bg_theme}
							boxShadow={"2xl"}
							padding={4}
						>
							<Flex flex={1} bg="blue.200">
								<Image
									objectFit="cover"
									boxSize="100%"
									src={project.hero_img}
								/>
							</Flex>
							<Stack
								flex={1}
								flexDirection="column"
								justifyContent="center"
								alignItems="center"
								p={1}
								pt={2}
							>
								<Heading fontSize={"2xl"} fontFamily={"body"}>
									{project.heading}
								</Heading>

								<Text textAlign={"center"} color={color_theme} px={3}>
									{project.description}
								</Text>
								<Stack
									align={"center"}
									justify={"center"}
									direction={{ base: "column", sm: "row", md: "row" }}
									mt={6}
									shouldWrapChildren="true"
								>
									{project.badge_1.map((badge) => {
										return (
											<Badge
												px={2}
												py={1}
												bg={badge_bg}
												fontWeight={"400"}
												key={50 * Math.random()}
											>
												{`#${badge}`}
											</Badge>
										);
									})}
								</Stack>
								<Stack
									align={"center"}
									justify={"center"}
									direction={{ base: "column", sm: "row", md: "row" }}
									mt={6}
									shouldWrapChildren="true"
								>
									{project.badge_2.map((badge2) => {
										return (
											<Badge
												px={2}
												py={1}
												bg={badge_bg}
												fontWeight={"400"}
												key={50 * Math.random()}
											>
												{`#${badge2}`}
											</Badge>
										);
									})}
								</Stack>

								<Link
									fontWeight={600}
									color={"gray.500"}
									size="sm"
									mb={4}
									href={`${project.git_repo}`}
									target={"_blank"}
								>
									Github Repo
								</Link>
								<Stack
									width={"100%"}
									mt={"2rem"}
									direction={"row"}
									padding={2}
									justifyContent={"space-between"}
									alignItems={"center"}
								>
									<Button
										flex={1}
										fontSize={"sm"}
										rounded={"full"}
										_focus={{
											bg: "gray.200",
										}}
										onClick={() => {
											window.open(`${project.demo_video_drive_link}`, "_blank");
										}}
										disabled={
											project.demo_video_drive_link === "#" ? true : false
										}
									>
										Demo Video
									</Button>
									<Button
										disabled={project.disableLiveSite}
										flex={1}
										fontSize={"sm"}
										rounded={"full"}
										bg={project.disableLiveSite ? "gray.400" : "blue.400"}
										color={"white"}
										boxShadow={
											"0px 1px 25px -5px rgb(66 153 225 / 48%), 0 10px 10px -5px rgb(66 153 225 / 43%)"
										}
										_hover={{
											bg: "blue.500",
										}}
										_focus={{
											bg: "blue.500",
										}}
										onClick={() => {
											window.open(`${project.deployed_link}`, "_blank");
										}}
									>
										Live Site
									</Button>
								</Stack>
							</Stack>
						</Stack>
					</Center>
				);
			})}
		</>
	);
}
